import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { AAMS_ACTION_TYPE } from "./aams-data.action";
import { AamsDataState, AamsTransaction, GameRound } from "./aams-data.model";

const initialState: AamsDataState = {};

export function aamsDataReducer(state = initialState, action: ActionWithPayload): AamsDataState {
	switch (action.type) {
		case AAMS_ACTION_TYPE.getLastGameRoundSuccess: {
			return updateState(state, {
				lastGameRound: action.payload as GameRound,
			});
		}
		case AAMS_ACTION_TYPE.getTransactionsSuccess: {
			return updateState(state, {
				transactions: action.payload as AamsTransaction,
			});
		}
		case AAMS_ACTION_TYPE.getSessionsSuccess: {
			return updateState(state, {
				sessions: action.payload as AamsTransaction,
			});
		}
		case AAMS_ACTION_TYPE.clearTransactions: {
			return updateState(state, {
				lastGameRound: undefined,
				transactions: undefined,
				sessions: undefined,
			});
		}
		default:
			return state;
	}
}
